import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

const URI_PREFIX = checkIsStoryBookPath('topics');
const TRENDS_PREFIX = checkIsStoryBookPath('trends');
const URI_PREFIX_SETTINGS = 'settings';

export const apiRoutes = (isTrends = false): any => {
  const moduleName = window.location.pathname?.split('/')?.[1];
  const isTrendModule = moduleName === 'trends' || isTrends;
  const GENERATE_URI = isTrendModule
    ? `${TRENDS_PREFIX}/${URI_PREFIX}`
    : URI_PREFIX;

  return {
    basic: GENERATE_URI,
    storeTopic: `${URI_PREFIX}/store`,
    updateTopic: `${URI_PREFIX}/update`,
    getTopic: `${GENERATE_URI}/show`,
    getGrabbingStatus: `${GENERATE_URI}/grabbing-status`,
    hideActionAllTab: `${GENERATE_URI}/trash-or-unnecessary`,
    topicsLastGrabbedOn: `${GENERATE_URI}/trending/last-grabbed-on`,
    allCountries: `${URI_PREFIX_SETTINGS}/countries/all`,

    //COMPARE TOPICS
    topInfluencer: `${GENERATE_URI}/top-influencers`,
    mostMentionedHashtags: `${GENERATE_URI}/most-mentions-hashtags`,
    trendingList: `${GENERATE_URI}/trending/list`,
    mostViewedVideos: `${GENERATE_URI}/most-viewed-videos`,
    compareTopic: `${GENERATE_URI}/map/countries`,
    compareTopics: `${GENERATE_URI}/compare`,
    numberOfMentions: `${GENERATE_URI}/compare/mentions-count`,
    newsTopicsChart: `${GENERATE_URI}/compare/news-count`,

    //CATEGORIES TABLE
    categoriesActiveTable: `${URI_PREFIX}/categories/active/all`,
    categoriesAutoComplete: `${URI_PREFIX}/categories/active`,
    categoriesTrashTable: `${URI_PREFIX}/categories/trash/all`,
    categoriesTrashAutoComplete: `${URI_PREFIX}/categories/trash`,
    trashCategory: `${URI_PREFIX}/categories/trash`,
    restoreCategory: `${URI_PREFIX}/categories/restore`,
    deleteCategory: `${URI_PREFIX}/categories/delete`,
    addToParentCategory: `${URI_PREFIX}/categories/attach`,
    parentCategories: `${URI_PREFIX}/categories/parent`,
    activeCategories: `${URI_PREFIX}/categories/active`,
    storeCategory: `${URI_PREFIX}/categories/store`,
    updateCategory: `${URI_PREFIX}/categories/update`,
    getCategory: `${URI_PREFIX}/categories/show`,

    unnecessaryAutoComplete: `${GENERATE_URI}/unnecessary`,
    analyzedAutoComplete: `${URI_PREFIX}/analyzed`,
    parentCategoriesAutoComplete: `${URI_PREFIX}/categories/parent`,
    allTopicsAutoComplete: `${GENERATE_URI}/all`,
    trendingAutoComplete: `${GENERATE_URI}/trending`,
    grabbedAutoComplete: `${URI_PREFIX}/grabbed`,
    trashedAutoComplete: `${URI_PREFIX}/trashed`,
    categoryAutoComplete: `${URI_PREFIX}/categories/active`,
    analyzedTopics: `${URI_PREFIX}/analyzed`,
    allTopics: `${URI_PREFIX}/all`,
    unnecessaryTopics: `${GENERATE_URI}/all-unnecessary`,
    trashedTopics: `${URI_PREFIX}/trashed`,
    trendingTopics: `${GENERATE_URI}/trending`,
    grabbedTopics: `${URI_PREFIX}/grabbed`,
    trendingTopTopics: `${URI_PREFIX}/top-trending`,
    trendingTopTopicsTrends: `${GENERATE_URI}/top-trending`,
    trashTopics: `${URI_PREFIX}/trash`,
    totalTopicsCount: `${URI_PREFIX}/total-topics-count`,
    totalCreatedCategories: `${URI_PREFIX}/total-categories-count`,
    topicsCategory: `${URI_PREFIX}/categories/topics-count`,
    topicsAdded: `${URI_PREFIX}/topics-count-chart`,
    trashTopic: `${URI_PREFIX}/trash`,
    restoreTopic: `${GENERATE_URI}/restore`,
    unnecessaryTopic: `${GENERATE_URI}/unnecessary`,
    addToAnalyzeTopic: `${URI_PREFIX}/analyze`,
    deleteTopic: `${URI_PREFIX}/delete`,

    // media filter auto complete
    mediakeywordsAutocomplete: `${URI_PREFIX}/topic-keywords`,
    mediaHashtagsAutocomplete: `${URI_PREFIX}/topic-hashtags`,

    // add new topic auto complete apis
    keywordsAutocomplete: `${URI_PREFIX}/tags`,
    hashtagsAutocomplete: `${URI_PREFIX}/hashtags`,
    // Topic details
    showTopic: `${GENERATE_URI}/show`,
    topicType: `${GENERATE_URI}/topic-types`,
    trendingRank: `${GENERATE_URI}/trending-countries`,
    topInfEntities: `${GENERATE_URI}/top-influencers`,
    topMentionedCountry: `${GENERATE_URI}/top-mentions-countries`,
    mentionsCard: `${GENERATE_URI}/mentions-count`,
    sourcesRelatedItems: `${GENERATE_URI}/source-details/related-news`,

    influencersAllRelated: `${GENERATE_URI}/influencer-details/media/all`,
    influencersYoutubeRelated: `${GENERATE_URI}/influencer-details/related-videos`,
    influencersTweetsRelated: `${GENERATE_URI}/influencer-details/related-tweets`,
    influencersLinkedinPostsRelated: `${GENERATE_URI}/influencer-details/related-linkedin-posts`,
    entitiesAllRelated: `${GENERATE_URI}/entity-details/media/all`,
    entitiesYoutubeRelated: `${GENERATE_URI}/entity-details/related-videos`,
    entitiesTweetsRelated: `${GENERATE_URI}/entity-details/related-tweets`,
    entitiesLinkedinPostsRelated: `${GENERATE_URI}/entity-details/related-linkedin-posts`,
    //related hashtags & keyword popup
    tweetsRelatedItems: `${GENERATE_URI}/media/tweets/related-items`,
    videosRelatedItems: `${GENERATE_URI}/media/videos/related-items`,
    newsRelatedItems: `${GENERATE_URI}/media/news/related-items`,
    postsRelatedItems: `${GENERATE_URI}/media/linkedin-posts/related-items`,
    resync: `${GENERATE_URI}/resync`,
    regrabb: `${GENERATE_URI}/trending/regrab`,
    logs: GENERATE_URI,
  };
};
